import { ChipOwnProps } from "@mui/material";
import moment from "moment";
import {
  BaseUser,
  DocumentVersion,
  DocumentVersionApprover,
  DocumentVersionApproverStatus,
} from "../../../../stores/models";

export const docInfoDrawerTabs = {
  approvers: "Approvers",
  activity: "Activity",
  revisions: "Revisions",
  docInfo: "Doc Info",
} as const;

export interface UserState extends BaseUser {
  approvalStatus?: keyof typeof DocumentVersionApproverStatus;
}

export interface Approver extends BaseUser {
  approvalStatus?: keyof typeof DocumentVersionApproverStatus;
}

export type AssignedUsers = (UserState | null)[];

export type EmptyObj = Record<PropertyKey, never>;

export const emptyUser = { firstName: "", lastName: "", email: "" };

export const userStatusDictionary: Record<
  string,
  { text: string; variant: ChipOwnProps["color"] }
> = {
  USER_INVITE_SENT: { text: "Invitation is pending", variant: "warning" },
  APPROVED: { text: "Reviewed and Approved on", variant: "success" },
  AWAITING_SIGNATURE: { text: "Awaiting approval", variant: "warning" },
};

export const formatDate = (date: Date) => moment(date).format("YYYY-MM-DD");

export const formatDateTime = (date: Date) =>
  `${moment.utc(date).format("YYYY-MM-DD HH:mm")} UTC`;

export const getDocumentVersionAuthoredAt = ({
  approvers,
  documentVersion,
}: {
  approvers: DocumentVersionApprover[];
  documentVersion: DocumentVersion;
}) => {
  const approversAssignedAt = approvers.reduce<Date | undefined>(
    (earliestDate, approver) =>
      !earliestDate || approver.createdAt < earliestDate
        ? approver.createdAt
        : earliestDate,
    undefined
  );

  return (
    documentVersion.readyForApprovalUpdatedAt ??
    approversAssignedAt ??
    documentVersion.createdAt
  );
};

export const getApproverStatusText = (approver: DocumentVersionApprover) => {
  if (approver.approvalStatus === DocumentVersionApproverStatus.APPROVED) {
    const dateTime = formatDateTime(new Date(approver.updatedAt));
    return `${userStatusDictionary[approver.approvalStatus].text} ${dateTime}`;
  }
  return userStatusDictionary[approver.approvalStatus].text;
};
